module.exports = __webpack_public_path__ + "img/scroll_bar.885e0725.png";